import { useTranslation } from "react-i18next";

import { StatusPill as Pill, type StatusTone } from "@/components/ui/status-pill";
import type { ToolStatus } from "../../types";

/**
 * Where a tool stands, for the back-office list. Same component and tones as the
 * financial-aid list; four states rather than six, since a tool has no
 * eligibility window (nothing can expire or be upcoming).
 */
const TONES: Record<ToolStatus, StatusTone> = {
  active: "success",
  unassociated: "warning",
  inactive: "muted",
  pending: "warning",
};

export function StatusPill({ status }: { status: ToolStatus }) {
  const { t } = useTranslation();
  return <Pill tone={TONES[status] ?? "muted"}>{t(`tools.admin.status.${status}`)}</Pill>;
}
